module.exports = __webpack_public_path__ + "static/img/qq交流群.18a1019f.png";